import { IAdherent } from './adherent.model';
import  { TypeSoutienEnum } from '../constant/enum';

export interface ICampAdherentSoutien {
  id?: number;
  typeSoutien?: TypeSoutienEnum;
  adherent?: IAdherent;
}

export class CampAdherentSoutien implements ICampAdherentSoutien {
  constructor(
    public id?: number,
    public typeSoutien?: TypeSoutienEnum,
    public adherent?: IAdherent,
  ) {
  }
}
